<nb-tabset fullWidth>
    <nb-tab *ngFor="let lang of to.languages" [tabTitle]="lang.toUpperCase()">
        
        <label class="horizontal control-label">{{ to.label }}</label>
        <input nbInput type="text" fullWidth [(ngModel)]="model[fieldKey][lang]">
        
    </nb-tab>
</nb-tabset>